import { useScrollReveal } from '../hooks/useScrollReveal';
import { useBooking } from '../context/BookingContext';

const MISO_MINI_IMG = 'https://customer-assets.emergentagent.com/job_heritage-prints-1/artifacts/rabix4e6_5bb4c21e-56a8-45df-88f5-ec642a498813.jpeg';

const FEATURES = [
  'Unlimited prints, every guest',
  '3–4 hours at your venue',
  'Custom event template (name + date)',
  'On-site MISO operator',
  'Setup & takedown included',
  'Free delivery within Hyderabad',
  'Digital gallery after the event',
];

export default function MisoMiniDetails() {
  const label = useScrollReveal(0);
  const heading = useScrollReveal(0.1);
  const features = useScrollReveal(0.2);
  const cta = useScrollReveal(0.3);
  const { openModal } = useBooking();

  return (
    <section
      id="pricing"
      data-testid="miso-mini-details"
      className="section-pad"
      style={{ backgroundColor: '#FAF5EF' }}
    >
      <div className="container-miso">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '80px',
            alignItems: 'center',
          }}
        >
          {/* Image */}
          <div
            className="img-hover-wrap"
            style={{
              borderRadius: '20px',
              overflow: 'hidden',
              aspectRatio: '4 / 5',
              backgroundColor: '#F0E8DF',
            }}
          >
            <img
              src={MISO_MINI_IMG}
              alt="Miso Mini close-up"
              loading="lazy"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
            />
          </div>

          {/* Details */}
          <div>
            <span ref={label.ref} style={label.style} className="section-label">
              Miso Mini — Available Now
            </span>

            <div className="airmail-stripe-sm" style={{ marginBottom: '24px' }} />

            <h2 ref={heading.ref} style={{ ...heading.style, marginBottom: '8px' }} className="h2-miso">
              Everything{' '}
              <span className="italic-accent" style={{ color: '#B85C3A' }}>included.</span>
            </h2>
            <p className="body-miso" style={{ marginBottom: '36px' }}>
              One flat price. No hidden costs. No surprises on event day.
            </p>

            {/* Feature list */}
            <ul
              ref={features.ref}
              style={{ ...features.style, listStyle: 'none', padding: 0, margin: '0 0 36px', display: 'flex', flexDirection: 'column', gap: '14px' }}
            >
              {FEATURES.map(f => (
                <li
                  key={f}
                  style={{
                    display: 'flex', alignItems: 'flex-start', gap: '12px',
                    fontFamily: 'Graphik, sans-serif',
                    fontWeight: 400, fontSize: '16px',
                    color: '#6B5D50', lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      width: '20px', height: '20px', borderRadius: '50%',
                      backgroundColor: 'rgba(184,92,58,0.1)',
                      border: '1px solid rgba(184,92,58,0.2)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0, marginTop: '2px',
                    }}
                  >
                    <span style={{ color: '#B85C3A', fontSize: '11px', fontWeight: 700 }}>✓</span>
                  </span>
                  {f}
                </li>
              ))}
            </ul>

            {/* Price + CTA */}
            <div ref={cta.ref} style={cta.style}>
              {/* Price */}
              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                  <span
                    data-testid="details-price"
                    style={{
                      fontFamily: 'Graphik, sans-serif',
                      fontWeight: 800,
                      fontSize: 'clamp(40px, 5vw, 52px)',
                      color: '#5C2424',
                      letterSpacing: '-0.03em',
                      lineHeight: 1,
                    }}
                  >
                    ₹18,000
                  </span>
                  <span style={{ fontFamily: 'Graphik, sans-serif', fontSize: '15px', color: '#9E8E7E' }}>
                    flat
                  </span>
                </div>
              </div>

              {/* CTA */}
              <button
                onClick={openModal}
                data-testid="details-book-btn"
                className="btn-primary"
                style={{ fontSize: '14px', padding: '16px 40px', marginBottom: '16px' }}
              >
                Book Miso Mini →
              </button>

              {/* Trust row */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '4px' }}>
                {['100% advance', 'Free cancellation 7 days'].map(t => (
                  <span key={t} style={{ fontFamily: 'Graphik, sans-serif', fontSize: '13px', color: '#9E8E7E', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ color: '#B85C3A', fontWeight: 700 }}>✓</span> {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
